import {
  Button,
  Card,
  Divider,
  HeaderWithAlert,
  Input,
  ModalConfirmation,
  SuccessAlert,
  ErrorAlert,
} from 'components';
import { useDeleteUser } from './hooks/useDeleteUser';
import { DeleteUserGuard } from './guards/DeleteUserGuard';
import './Delete-user.scss';
import { IDetailStep } from 'models';

export const DeleteUser = () => {
  const {
    email,
    emailError,
    isTouched,
    isLoading,
    showConfirmation,
    successMessage,
    setSuccessMessage,
    errorMessage,
    setErrorMessage,
    isFormValid,
    handleEmailChange,
    handleEmailBlur,
    handleDeleteClick,
    handleConfirmDelete,
    handleCancelDelete,
    handleBack,
  } = useDeleteUser();

  const handleCloseSuccess = () => {
    setSuccessMessage('');
  };

  const handleCloseError = () => {
    setErrorMessage('');
  };

  const steps = [
    {
      description: 'ajustes',
      state: 'active',
      link: '/settings',
      permissionToNavigate: true,
    },
    {
      description: 'borrar usuario',
      state: 'active',
      link: '/settings/delete-user',
      permissionToNavigate: false,
    },
  ];

  return (
    <DeleteUserGuard>
      <HeaderWithAlert
        title=""
        message=""
        steps={steps as IDetailStep[]}
        showAlert={undefined}
        onClick={handleBack}
      />

      <section className="delete-user__container">
        <div className="delete-user__content">
          <Card WrapperClassName="delete-user__card">
            <div className="delete-user__header">
              <h2 className="delete-user__title">Eliminar Usuario</h2>
              <p className="delete-user__description">
                Ingresa el email del usuario que deseas eliminar. Esta acción no
                se puede deshacer.
              </p>
            </div>

            <div className="delete-user__form">
              <Input
                type="email"
                name="email"
                id="email"
                placeholder="Ingresa el email del usuario"
                label="Email del usuario"
                value={email}
                onChange={handleEmailChange}
                onBlur={handleEmailBlur}
                errorLabel={emailError}
                errorInput={emailError}
                isTouched={isTouched}
                isRequired={true}
                WrapperClassName="delete-user__input"
              />

              <div className="delete-user__actions">
                <Button
                  template="secondary"
                  typeStyle="square"
                  color="primary"
                  size="medium"
                  onClick={handleBack}
                  isDisabled={isLoading}
                >
                  Cancelar
                </Button>
                <Button
                  template="primary"
                  typeStyle="square"
                  color="primary"
                  size="medium"
                  onClick={handleDeleteClick}
                  isDisabled={!isFormValid || isLoading}
                  isLoading={isLoading}
                >
                  Eliminar Usuario
                </Button>
              </div>
            </div>
          </Card>
        </div>

        {successMessage && (
          <SuccessAlert
            message={successMessage}
            onClose={() => handleCloseSuccess()}
            isOpen={true}
            title="Usuario eliminado"
          />
        )}

        {errorMessage && (
          <ErrorAlert
            message={errorMessage}
            onClose={() => handleCloseError()}
            isOpen={true}
            title="Error al eliminar usuario"
          />
        )}
      </section>

      <ModalConfirmation
        isOpen={showConfirmation}
        onClose={handleCancelDelete}
        onConfirm={handleConfirmDelete}
        title="Confirmar Eliminación"
        message={`¿Estás seguro que deseas eliminar el usuario con email: ${email}? Esta acción no se puede deshacer.`}
        confirmText="Sí, eliminar"
        cancelText="Cancelar"
        isLoading={isLoading}
      />
    </DeleteUserGuard>
  );
};
